(() => {
  const setLabel = (button, expanded) => {
    const label = button.querySelector('[data-salut-chips-toggle-label]');
    if (!label) return;
    label.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
  };

  document.querySelectorAll('[data-salut-chips]').forEach((nav) => {
    const button = nav.querySelector('[data-salut-chips-toggle]');
    if (!button) return;

    button.addEventListener('click', () => {
      const expanded = nav.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(expanded));
      setLabel(button, expanded);
    });
  });
})();
